import React from "react";
import { QuizData } from "../../data/quizzData";
import "../../styles/SimpleQuizz/DisplayQuestionnaire.css";
import { ZoneQuestions } from "./ZoneQuestions/ZoneQuestions";
import { ZoneReponses } from "./ZoneReponses/ZoneReponses";

// Composant qui affiche le questionnaire, et permet son fonctionnement

export const DisplayQuestionnaire = ({
  questionId,
  setQuestionId,
  userAnswers,
  setUserAnswers,
}) => {
  const question = QuizData[questionId];
  const numberOfQuestions = QuizData.length;

  return (
    <div className="container_quiz">
      <div className="zone_texte">
        <ZoneQuestions dataNumeroId={question} />
      </div>
      <ZoneReponses
        question={question}
        questionId={questionId}
        setQuestionId={setQuestionId}
        userAnswers={userAnswers}
        setUserAnswers={setUserAnswers}
        numberOfQuestions={numberOfQuestions}
      />
    </div>
  );
};
